import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import api, { formatApiError } from "../api";

export const ChangePasswordDialog = ({ mobile }) => {
  const [open, setOpen] = useState(false);
  const [oldPw, setOldPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (newPw !== confirmPw) { toast.error("Konfirmasi password baru tidak sama"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { old_password: oldPw, new_password: newPw });
      toast.success("Password berhasil diubah");
      setOpen(false);
      setOldPw(""); setNewPw(""); setConfirmPw("");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <button data-testid={mobile ? "mobile-change-password-button" : "change-password-button"}
        onClick={() => setOpen(true)}
        className="flex items-center gap-2 text-sm text-zinc-600 hover:text-emerald-700 transition-colors duration-200 mb-2">
        <KeyRound className="w-4 h-4" /> Ubah Password
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="change-password-dialog" className="sm:max-w-md bg-white">
          <DialogHeader>
            <DialogTitle>Ubah Password</DialogTitle>
            <DialogDescription>Masukkan password lama lalu tentukan password baru (min. 6 karakter).</DialogDescription>
          </DialogHeader>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label>Password Lama</Label>
              <Input data-testid="old-password-input" type="password" required value={oldPw}
                onChange={(e) => setOldPw(e.target.value)} className="bg-white input-touch" />
            </div>
            <div className="space-y-1.5">
              <Label>Password Baru</Label>
              <Input data-testid="new-password-input" type="password" required minLength={6} value={newPw}
                onChange={(e) => setNewPw(e.target.value)} placeholder="Min. 6 karakter" className="bg-white input-touch" />
            </div>
            <div className="space-y-1.5">
              <Label>Ulangi Password Baru</Label>
              <Input data-testid="confirm-password-input" type="password" required minLength={6} value={confirmPw}
                onChange={(e) => setConfirmPw(e.target.value)} className="bg-white input-touch" />
            </div>
            <Button data-testid="submit-change-password" type="submit" disabled={saving}
              className="w-full btn-touch bg-emerald-700 hover:bg-emerald-800 text-white transition-colors duration-200">
              {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <KeyRound className="w-4 h-4 mr-2" />} Simpan Password Baru
            </Button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};
